<img id="logo" ngSrc="assets/img/ogi-logo.png" width="200" height="51" alt="OGI Logo" priority />
<div id="page">
  <div id="container">
    <h4>Awaiting Confirmation</h4>
    <p>
      A verification link has been sent to your email address. Please click the
      link in that email to confirm your email address. If you need further
      help, please contact help&#64;ogibiotec.com.
    </p>
    <a [routerLink]="'/login'" class="button-styling">Return to login</a>
  </div>
</div>
